export default {
  'menu.workbench': '工作台',
  'menu.enterprise': '我的企业',
  'menu.enterprise.profile': '企业档案',
  'menu.enterprise.operation': '企业经营',
  'menu.enterprise.recommendations': '成长推荐',
  'menu.parks': '园区',
  'menu.parks.list': '我的园区',
  'menu.parks.applications': '入驻申请',
  'menu.parks.authorization': '数据授权',
  'menu.parks.leases': '我的租赁',
  'menu.parks.entries': '我的入驻',
  'menu.parks.invitations': '园区邀请',
  'menu.services': '企业服务',
  'menu.services.hall': '服务大厅',
  'menu.services.hall.matterDetail': '服务事项详情',
  'menu.services.hall.apply': '申请服务事项',
  'menu.services.property': '园区物业',
  'menu.services.property.accessControl': '访客与门禁',
  'menu.services.property.accessControlNew': '新建访客申请',
  'menu.services.property.accessControlDetail': '访客申请详情',
  'menu.services.property.vehicles': '我的车辆',
  'menu.services.property.workOrders': '物业工单',
  'menu.services.property.repair': '我要报修',
  'menu.services.property.complaint': '我要投诉',
  'menu.services.property.serviceRequest': '服务请求',
  'menu.services.handling': '服务办理',
  'menu.services.handling.applications': '我的申请',
  'menu.services.handling.enterpriseRequests': '我的诉求',
  'menu.services.handling.applicationDetail': '申请详情',
  'menu.services.handling.catalog': '服务目录',
  'menu.services.handling.demands': '我的需求',
  'menu.services.handling.orders': '我的订单',
  'menu.resources': '园区资源',
  'menu.resources.news': '园区资讯',
  'menu.resources.news.announcements': '通知公告',
  'menu.resources.news.policies': '政策服务',
  'menu.resources.news.policyDetail': '政策详情',
  'menu.resources.news.activities': '园区活动',
  'menu.parkActivities': '园区活动',
  'menu.resources.industry': '产业孵化',
  'menu.resources.industry.ecosystem': '产业资源',
  'menu.resources.industry.finance': '投融资',
  'menu.resources.industry.investmentProjects': '招商项目',
  'menu.resources.industry.incubationPrograms': '孵化计划',
  'menu.resources.industry.mentors': '创业导师',
  'menu.data': '数据管理',
  'menu.data.submissions': '数据填报',
  'menu.data.materials': '企业材料',
  'menu.data.usage': '数据使用记录',
  'menu.data.energy': '能耗查询',
  'menu.settings': '系统设置',
  'menu.settings.permissions': '权限管理',
  'menu.more-blocks': '更多区块',
  'menu.home': '首页',
  'menu.admin': '管理页',
  'menu.admin.sub-page': '二级管理页',
  'menu.system': '系统管理',
  'menu.system.menu': '菜单管理',
  'menu.system.user': '用户管理',
  'menu.system.role': '角色管理',
  'menu.login': '登录',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': '分析页',
  'menu.dashboard.monitor': '监控页',
  'menu.dashboard.workplace': '工作台',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': '表单页',
  'menu.form.basic-form': '基本表单',
  'menu.form.step-form': '分步表单',
  'menu.form.step-form.info': '分步表单（填写转账信息）',
  'menu.form.step-form.confirm': '分步表单（确认转账信息）',
  'menu.form.step-form.result': '分步表单（完成）',
  'menu.form.advanced-form': '高级表单',
  'menu.list': '列表页',
  'menu.list.table-list': '查询表格',
  'menu.list.basic-list': '标准列表',
  'menu.list.card-list': '卡片列表',
  'menu.list.search-list': '搜索列表',
  'menu.list.search-list.articles': '搜索列表（文章）',
  'menu.list.search-list.projects': '搜索列表（项目）',
  'menu.list.search-list.applications': '搜索列表（应用）',
  'menu.profile': '详情页',
  'menu.profile.basic': '基础详情页',
  'menu.profile.advanced': '高级详情页',
  'menu.result': '结果页',
  'menu.result.success': '成功页',
  'menu.result.fail': '失败页',
  'menu.exception': '异常页',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': '触发错误',
  'menu.account': '个人页',
  'menu.account.center': '个人中心',
  'menu.account.workbench': '回到工作台',
  'menu.account.tenantManagement': '企业管理',
  'menu.account.trigger': '触发报错',
  'menu.account.logout': '退出登录',
  'menu.editor': '图形编辑器',
  'menu.editor.flow': '流程编辑器',
  'menu.editor.mind': '脑图编辑器',
  'menu.editor.koni': '拓扑编辑器',
};
